// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wYj6","left":"styles_left__3JAen","desktopActions":"styles_desktopActions__2AWzA","title":"styles_title__vVxbm"};